import React from "react"
import { useTranslation } from "react-i18next"

function PPMatchingTarifView(props) {
    const [t] = useTranslation()

    let volume = ""
    let effektivpreis = ""
    let laufzeit = ""
    let netz = ""
    let downloadSpeed = ""
    let uploadSpeed = ""
    Object.entries(props.tarifData?.tarif?.tarifInfoMap ?? {}).forEach(([propertyName, tarifData]) => {
        if (propertyName === "volume") {
            volume = tarifData.value
        } else if (propertyName === "effektivpreis") {
            effektivpreis = tarifData.value + " €"
        } else if (propertyName === "laufzeit") {
            laufzeit = tarifData.value
        } else if (propertyName === "netz") {
            netz = tarifData.value
        } else if (propertyName === "geschwindigkeit_download") {
            downloadSpeed = tarifData.value
        } else if (propertyName === "geschwindigkeit_upload") {
            uploadSpeed = tarifData.value
        }
    })
    return (
        <ul className="tarif-data">
            {effektivpreis !== "" && (
                <li>
                    {t("pricetable.tarif_data.effectiveCosts")}: {effektivpreis}
                </li>
            )}
            {laufzeit !== "" && (
                <li>
                    {t("pricetable.tarif_data.duration")}: {laufzeit}
                </li>
            )}
            {volume !== "" && (
                <li>
                    {t("pricetable.tarif_data.volume")}: {volume}
                </li>
            )}
            {netz !== "" && (
                <li>
                    {t("pricetable.tarif_data.network")}: {netz}
                </li>
            )}
            {downloadSpeed !== "" && (
                <li>
                    {t("pricetable.tarif_data.downloadSpeed")}: {downloadSpeed}
                </li>
            )}
            {uploadSpeed !== "" && (
                <li>
                    {t("pricetable.tarif_data.uploadSpeed")}: {uploadSpeed}
                </li>
            )}
        </ul>
    )
}

export default PPMatchingTarifView
